import type { Features } from '@/hooks/useSettings';
import type { UserPreferencesFeaturesPatch, UserPreferencesValues } from '@/pages/settings/userPreferences.types';

export const fromFeatures = (features: Features): UserPreferencesValues => ({
  preserveAppendSummary: features.preserve_append_summary === true,
  // Missing means on, matching the server default.
  enableTodoList: features.enable_todo_list !== false,
  enableRuleBasedNormalization: features.enable_rule_based_normalization === true,
  defaultSessionMode: features.default_session_mode === 'dictation' ? 'dictation' : 'conversation',
  asrModelPreference: features.asr_model_preference || null,
  letterSignature: typeof features.letter_signature === 'string' ? features.letter_signature : '',
});

/** Only the edited fields, as feature keys; an empty signature is cleared (null). */
export const toFeaturesPatch = (
  values: UserPreferencesValues,
  dirtyFields: Partial<Record<keyof UserPreferencesValues, boolean>>
): UserPreferencesFeaturesPatch => ({
  ...(dirtyFields.preserveAppendSummary && { preserve_append_summary: values.preserveAppendSummary }),
  ...(dirtyFields.enableTodoList && { enable_todo_list: values.enableTodoList }),
  ...(dirtyFields.enableRuleBasedNormalization && {
    enable_rule_based_normalization: values.enableRuleBasedNormalization,
  }),
  ...(dirtyFields.defaultSessionMode && { default_session_mode: values.defaultSessionMode }),
  ...(dirtyFields.asrModelPreference && { asr_model_preference: values.asrModelPreference }),
  ...(dirtyFields.letterSignature && { letter_signature: values.letterSignature || null }),
});
